import { Inject, Injectable, InjectionToken } from '@angular/core';
import { ICategory } from '../interface/app-tsc.interface';

interface IStorageService<T> {
  get<K extends keyof T>(key: K): T[K] | null;
  set<K extends keyof T>(key: K, value: T[K]): void;
  remove<K extends keyof T>(key: K): void;
  clear(): void;
}

const NAMESPACE = 'TSC';

export enum LS {
  categoryState = `${NAMESPACE}-categoryState`,
  categoryList = `${NAMESPACE}-categoryList`,
}

export interface ILocalStorageModel {
  [LS.categoryState]: ICategory;
  [LS.categoryList]: ICategory[];
}

// const BROWSER_STORAGE = new InjectionToken('Browser Storage', {
//   providedIn: 'root',
//   factory: () => localStorage,
// });

// สร้างตัวแปรคงที่ชื่อ BROWSER_STORAGE เป็น InjectionToken ของชนิด Storage
const BROWSER_STORAGE = new InjectionToken<Storage>('Browser Storage', {
  // ให้บริการ token นี้ใน root injector (ทั้งแอปสามารถใช้งานได้)
  providedIn: 'root',

  // factory function จะเป็นตัวกำหนดว่าจะคืนค่าอะไร
  factory: () => {
    // ถ้าโค้ดนี้รันบน browser และมี localStorage
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage; // ใช้ localStorage จริง
    }

    // ถ้าไม่มี localStorage (เช่น SSR หรือ Node.js)
    // คืนค่า object ปลอม (mock) ของ Storage เพื่อไม่ให้โค้ดพัง
    return {
      length: 0,              // จำนวน key ใน storage
      clear() {},             // เคลียร์ข้อมูลทั้งหมด
      getItem() { return null; }, // อ่านค่า key (แต่ไม่มีข้อมูล)
      key() { return null; },      // คืนค่า key ตาม index
      removeItem() {},        // ลบ key (ไม่ทำอะไรจริง)
      setItem() {},           // เซ็ตค่า key (ไม่ทำอะไรจริง)
    } as Storage;
  }
});

@Injectable({
  providedIn: 'root',
})
export class StorageService implements IStorageService<ILocalStorageModel> {
  constructor(@Inject(BROWSER_STORAGE) private storage: Storage) {}

  get<K extends keyof ILocalStorageModel>(key: K): ILocalStorageModel[K] | null {
    const value = this.storage.getItem(key.toString());

    if (value === null || value === 'null' || value === undefined || value === 'undefined') {
      return null;
    }
    return JSON.parse(value);
  }

  set<K extends keyof ILocalStorageModel>(key: K, value: ILocalStorageModel[K]): void {
    this.storage.setItem(key.toString(), JSON.stringify(value));
  }

  remove<K extends keyof ILocalStorageModel>(key: K): void {
    this.storage.removeItem(key.toString());
  }

  clear(): void {
    this.storage.clear();
  }
}
